import React from "react";
//import { useAuth } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext_V2";
import LogoutModal from "./components/ui/LogoutModal";
import Navigation from "./components/navigation/Navigation";
import { Outlet, Navigate } from "react-router-dom";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import NewReportPanel from "./components/ui/create-report/NewReportPanel";
import NewActionPlanPanel from "./components/ui/action-plans/create-action-plan/NewActionPlanPanel";
import NewCorrectiveActionPanel from "./components/ui/action-plans/create-corrective-action/NewCorrectiveActionPanel";
import ErrorBanner from "./components/ui/shared/error-banner";
import Spinner from "./components/ui/shared/spinner";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";

function RootLayout() {
  const { keycloak, state, send } = useAuth();
  const { t } = useTranslation();

  if (state.matches("error")) {
    return <Navigate to="/" replace />; // or render error inline
  }

  return (
    <>
      <div>
        <Navigation>
          <Outlet />
        </Navigation>
        <LogoutModal />
        <NewReportPanel />
        <NewActionPlanPanel />
        <NewCorrectiveActionPanel />
        {state.matches("authenticated.retrying refresh") && (
          <ErrorBanner>
            <Trans
              i18nKey="errors.token_refresh_failed"
              values={{
                count: state.context.retryRefreshAttempts,
                maxRetries: state.context.maxRefreshRetries,
              }}
              components={{
                spinner: (
                  <Spinner color="red" sizeClass="h-4 w-4 sm:h-5 sm:w-5 " />
                ),
                exclamation: (
                  <ExclamationTriangleIcon
                    className="h-8 w-8  text-red-500 dark:text-red-400  sm:h-5 sm:w-5"
                    aria-hidden="true"
                  />
                ),
              }}
            />
          </ErrorBanner>
        )}
      </div>
    </>
  );
}

export default RootLayout;
